export default __webpack_public_path__ + "static/media/Low-Poly-Spaceships-00.5eadf685.jpg";